import { SINGLE_API } from 'src/redux/actions/type';
import { GET_PDF } from './type';

// export const MODEL_NAME = 'USER';
// export const MODEL_PLURAL = 'users';

export const getListScheduledTransactions = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	const {params} = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/scheduled-transactions',
            opt: {
			    headers: {
			        Accept: 'application/ld+json'
                }
            },
			params,
			beforeCallType: 'GET_SCHEDULED_TRANSACTION_LIST_REQUEST',
			successType: 'GET_SCHEDULED_TRANSACTION_LIST_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getListTransactions = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions',
            opt: {
			    headers: {
			        Accept: 'application/ld+json'
                }
            },
			params: payload,
			beforeCallType: 'GET_TRANSACTION_LIST_REQUEST',
			successType: 'GET_TRANSACTION_LIST_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};
export const filterTransactions = (payload, next, nextErr) => {
	// const { before, after } = payload;
	// console.log(`/transactions.json?date[before]=${before}&date[after]=${after}`);
	return {
		type: SINGLE_API,
		payload: {
			// uri: `/transactions.json?date[before]=${before}&date[after]=${after}&pagination=false&type[0]=1`,
			uri: '/transactions',
			params: payload,
			beforeCallType: 'FILTER_TRANSACTIONS_REQUEST',
			successType: 'FILTER_TRANSACTIONS_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getTransactionsByUserId = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions/search',
			params: payload,
			opt: {
				headers: { Accept: 'application/ld+json' }
			},
			beforeCallType: 'GET_TRANSACTION_BY_USER_ID_REQUEST',
			successType: 'GET_TRANSACTION_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getTransactionsByUserIdOfEmployee = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions',
			params: payload,
			beforeCallType: 'GET_TRANSACTION_BY_USER_ID_REQUEST',
			successType: 'GET_TRANSACTION_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getCreditsByUserId = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions/search',
			params: payload,
			opt: {
				headers: { Accept: 'application/ld+json' }
			},
			beforeCallType: 'GET_CREDIT_BY_USER_ID_REQUEST',
			successType: 'GET_CREDIT_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getCreditsByUserIdOnEmployee = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions',
			params: payload,
			beforeCallType: 'GET_CREDIT_BY_USER_ID_REQUEST',
			successType: 'GET_CREDIT_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const cancelScheduledTransactions = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'POST' },
			uri: '/cancel-scheduled-transactions',
			params: payload,
			beforeCallType: 'GET_CREDIT_BY_USER_ID_REQUEST',
			successType: 'GET_CREDIT_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const getDailyTransactionsByUserId = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: '/transactions/daily-statistics',
			params: payload,
			beforeCallType: 'GET_DAILY_TRANSACTIONS_BY_USER_ID_REQUEST',
			successType: 'GET_DAILY_TRANSACTIONS_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const getRestaurantRefundsHistory = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: '/restaurant-refunds',
			params: payload,
			beforeCallType: 'GET_RESTAURANT_REFUNDS_HISTORY_REQUEST',
			successType: 'GET_RESTAURANT_REFUNDS_HISTORY_SUCCESS',
			afterSuccess: next,
			afterError: nextErr,
		}
	};
}

export const getRestaurantRefundsHistoryDetails = (payload, next, nextErr) => {
	const { userId, dateAfter, dateBefore } = payload;

	// const dateAfter = '2021-12-01';
	// const dateBefore = '2021-12-31';

	return {
		type: SINGLE_API,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: `/transactions?type=1&creditor.id=${userId}&date[after]=${dateAfter} 00:00:00&date[before]=${dateBefore} 23:59:59&pagination=false`,
			params: payload,
			beforeCallType: 'GET_RESTAURANT_REFUNDS_HISTORY_DETAILS_REQUEST',
			successType: 'GET_RESTAURANT_REFUNDS_HISTORY_DETAILS_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const getRestaurantTransactionHistory = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions',
			params: payload,
			opt: {
				headers: { Accept: 'application/ld+json' }
			},
			beforeCallType: 'GET_CREDIT_BY_USER_ID_REQUEST',
			successType: 'GET_CREDIT_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getTransactionsDebitorCreditorById = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/get-transactions-by-user-id',
			params: payload,
			opt: {
				headers: { Accept: 'application/ld+json' }
			},
			// beforeCallType: 'GET_CREDIT_BY_USER_ID_REQUEST',
			// successType: 'GET_CREDIT_BY_USER_ID_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const cancelTransaction = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions/cancel-transaction',
            opt: {
				method: 'POST',
			    headers: {
			        Accept: 'application/ld+json'
                }
            },
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

// NEW CODE BY DEV-TERE
// Uitiliser cette route pour les historiques des transactions 
// params: companyId for companyHistory, employeeId for employeeHistory, restaurantId for restaurantHistory
// Filter: dateStart, dateEnd, search, amount 

export const getTransactionHistory = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: '/transactions-history',
            opt: {
			    headers: {
			        Accept: 'application/ld+json'
                }
            },
			params: payload,
			beforeCallType: 'GET_TRANSACTION_LIST_REQUEST',
			successType: 'GET_TRANSACTION_LIST_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};




